import { render, staticRenderFns } from "./TablePagination.vue?vue&type=template&id=df3462c0&scoped=true&"
import script from "./TablePagination.vue?vue&type=script&lang=js&"
export * from "./TablePagination.vue?vue&type=script&lang=js&"
import style0 from "./TablePagination.vue?vue&type=style&index=0&id=df3462c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3462c0",
  null
  
)

export default component.exports